import * as createHistory from "history";
// Instead of BrowserRouter, we use the regular router,
// but we pass in a customer history to it.
export const history = createHistory.createBrowserHistory();
export function getTimeoutSeconds() {
    var sTO = 1800000;
    var cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("userTimeoutSeconds="))
        ?.split("=")[1];
    if (!cookieValue) {
        //alert('Cookie Value: userTimeoutSeconds is not available');
        cookieValue = '30m'
    }
    if (cookieValue.indexOf('m') > 0) {
        sTO = parseInt(cookieValue.replace('m','')) * 60000;
    }
    else if (cookieValue.indexOf('hr') > 0) {
        sTO = parseInt(cookieValue.replace('hr','')) * 3600000;
    }
    return sTO;
}
